import { render, staticRenderFns } from "./about-project.vue?vue&type=template&id=76def402&scoped=true"
import script from "./about-project.vue?vue&type=script&lang=ts"
export * from "./about-project.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76def402",
  null
  
)

export default component.exports